import { useNavigate } from 'react-router-dom';
import { Text, Block, Button } from '../../../components';
import { routes } from '../../../routes';

const SuccessUnsubscribePage = function () {
  const navigate = useNavigate();
  return (
    <Block 
    display='flex' 
    direction='column' 
    justify='center' 
    align='center' 
    mt='l'
    mb='l'
    >
      <Text 
        fontFamily="title"
        weight="bold"
        customStyles={{ fontSize: '2rem'}}
      >
        👋 
      </Text>
      <Text 
        as="h2"
        fontFamily="title"
        weight="bold"
        mb="l"
        fontSize='xs'
      >
        Lamentamos que quieras irte...
      </Text>
      <Text 
        as="h4"
        fontFamily="title"
        fontSize="m"
        weight='medium'
        mb="l"
      >
        Gracias por haber formado parte de Sinaglife.<br/>
        Tu energia siempre sera bienvenida aqui✨
      </Text>
      <Text 
        as="h4"
        fontFamily="title"
        fontSize="m"
        weight='bold'
        mb="xl"
      >
        Tu baja ha sido procesada con éxito
      </Text>
      <Block 
      width='100%'
      display='flex'
      justify='space-between'
      customStyles={{minWidth: '330px', maxWidth: '370px'}}
      >
        <Button 
        text="Volver al inicio" 
        onClick={() => navigate('/')} 
        variant="outlined" 
        size="m" 
        color="earth" 
        />
        <Button 
        text="Explorar accesorios" 
        onClick={() => navigate(routes.STORE_DEPARTMENTS)} 
        variant="default" 
        size="m" 
        color="mediumEarth" 
        />
      </Block>
    </Block>
  );
};

export default SuccessUnsubscribePage;
